/**
 * White Label Configuration Loader
 * 
 * This file provides functions to load white label configurations
 * and customize the application at runtime.
 */

import brandingConfig from './brandingConfig';

/**
 * Load a white label configuration by brand ID
 * This allows dynamically switching brands when needed
 */
export const loadBrandConfig = async (brandId) => {
  // For future implementation:
  // 1. Load brand config from external source (API, file, etc.)
  // 2. Merge with default config
  // 3. Apply and refresh UI
  
  // Currently returns default config
  return brandingConfig;
};

/**
 * Apply theme to Material-UI
 */
export const applyTheme = (theme, config = brandingConfig) => {
  // Update theme with branding colors
  theme.palette.primary.main = config.colors.primary;
  theme.palette.secondary.main = config.colors.secondary;
  theme.palette.error.main = config.colors.error;
  theme.palette.warning.main = config.colors.warning;
  theme.palette.info.main = config.colors.info;
  theme.palette.success.main = config.colors.success;
  
  // Update typography
  theme.typography.fontFamily = config.ui.fontFamily;
  
  // Update UI elements
  theme.shape.borderRadius = parseInt(config.ui.borderRadius);
  
  return theme;
};

/**
 * Get correct asset path for a logo
 * This handles both relative and absolute paths
 */
export const getLogoUrl = (logoKey) => {
  const logoPath = brandingConfig.logos[logoKey];
  
  if (!logoPath) {
    return null;
  }
  
  // Handle absolute URLs
  if (logoPath.startsWith('http')) {
    return logoPath;
  }
  
  // Handle public assets
  if (logoPath.startsWith('/')) {
    return process.env.PUBLIC_URL + logoPath;
  }
  
  // Handle relative paths
  return logoPath;
};

/**
 * Get document title for browser tab
 */
export const getDocumentTitle = (pageTitle) => {
  if (pageTitle) {
    return `${pageTitle} | ${brandingConfig.appName}`;
  }
  return brandingConfig.appName;
};

/**
 * Helper to get feature flag
 */
export const isFeatureEnabled = (featureKey) => {
  return !!brandingConfig.features[featureKey];
};

export default brandingConfig;